export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('GuidesTabs', (data) => {
        const groupedRows = {};
        const groupedHeaders = data.map((item) => {
          return item.title;
        });
        if (data.length > 0) {
          data[0].rows.forEach((row, index) => {
            const columns = data.length;
            for (let i = 0; i < columns; i++) {
              groupedRows[index] = groupedRows[index] || [];
              groupedRows[index].push(data[i].rows[index]);
            }
          });
        }
        return {
          activeTab: 0,
          nextTab() {
            if (this.activeTab + 1 < Object.keys(this.rows).length) {
              this.activeTab = this.activeTab + 1;
            } else {
              this.activeTab = 0;
            }
          },
          prevTab() {
            if (this.activeTab - 1 >= 0) {
              this.activeTab = this.activeTab - 1;
            } else {
              this.activeTab = Object.keys(this.rows).length - 1;
            }
          },
          rows: groupedRows,
          headers: groupedHeaders,
        };
      });
    });
  },
};
